import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";

export default function MealPlanListPage() {
  const [plans, setPlans] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    apiClient
      .get(`/mealplans`)
      .then((res) => setPlans(res.data));
  }, []);

  const filteredPlans = plans.filter((plan) =>
    plan.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="max-w-3xl mx-auto px-4 mt-10">
      <h1 className="text-2xl font-bold mb-4">My Meal Plans</h1>

      <input
        type="text"
        placeholder="Search meal plans..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full border border-gray-300 px-3 py-2 rounded mb-4"
      />

      {filteredPlans.length === 0 ? (
        <p className="text-gray-600">
          {search
            ? "No meal plans match your search."
            : "You haven’t created any meal plans yet."}
        </p>
      ) : (
        <div className="space-y-4">
          {filteredPlans.map((plan) => (
            <div
              key={plan._id}
              className="border rounded p-4 bg-white shadow-sm hover:shadow transition"
              onClick={() => navigate(`/mealplan/${plan._id}`)}
              style={{ cursor: "pointer" }}
            >
              <h2 className="text-lg font-semibold">{plan.name}</h2>
              <p className="text-sm text-gray-600">
                {plan.recipes.length} recipe{plan.recipes.length !== 1 && "s"}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
